export default {
  allPositionsInfo(state) {
    return state.positionById;
  },
};
